import React, { Component } from 'react'
import { Button, Modal, ModalBody, ModalHeader, Label, Col, Row, Form, FormGroup, Input, FormFeedback } from 'reactstrap'
import DropzoneComponent from 'react-dropzone-component'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { createOrUpdateLogMutation, InspectionLogDataFetchQuery } from '../EventLog/mutations'
import CreatableSelect from '../Wps/CreatableSelect'
import { graphql, compose } from 'react-apollo'
import ConvertInput from '../EventLog/ConvertInput'
import { UploadFiles, acceptedFiles, acceptedFilesIcons } from '../../utils/uploadFiles'
import { destroyAttachmentsMutation } from '../Projects/mutations'
import BlockWithLoader from '../Support/BlockWithLoader'
// import {withGaTracker, withGaEvent} from '../Support/GoogleAnalytics'
import { API_BASE_URL } from '../../utils/apiConfig'
import peopleList from './helpers/peopleList'
import { getUserPermissions } from '../../utils/userPermissions'

class InspectionLogModal extends Component {
  constructor(props) {
    super(props)
    const ri_type = props.inspCatTypesDict.find(o => o.name === 'RI')
    this.state = {
      log_data_input: [{ additional_name: '', additional_value: '' }],
      type: 'WlWelds::Logs::Inspection',
      inspection_percentage: null,
      person_id: null,
      validationErrors: null,
      files: [],
      filesSelectedToRemove: [],
      nextSubmitWeldsId: null,
      submittedWeldsId: [],
      ri_type_id: ri_type ? Number(ri_type.id) : false,
      is_ri_type: false,
      people_list: [],
      isSubmitting: false,
      double_length: false,
      gauging: false,
      bypass_hold_time: false,
      inspection: {},
      complete_mm: null,
      weld_failed_mm: null
    }

    this.peopleList = peopleList.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleOnSelectInspectionLogChange = this.handleOnSelectInspectionLogChange.bind(this)
    this.handleDeleteInput = this.handleDeleteInput.bind(this)
    this.handleAddDynamicInput = this.handleAddDynamicInput.bind(this)
    this.handleSelectValueChange = this.handleSelectValueChange.bind(this)
    this.handleSkipInspection = this.handleSkipInspection.bind(this)

    this.djsConfig = {
      addRemoveLinks: true,
      autoProcessQueue: false,
      acceptedFiles: acceptedFiles,
      maxFiles: 1,
    }
    this.componentConfig = {
      iconFiletypes: acceptedFilesIcons,
      showFiletypeIcon: true,
      postUrl: 'no-url',
    }
    this.dropzone = null
  }

  static propTypes = {
    createOrUpdateLogMutation: PropTypes.func.isRequired,
    destroyAttachmentsMutation: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
    isOpened: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    afterSubmit: PropTypes.func.isRequired,
    editData: PropTypes.object,
    weldsData: PropTypes.array.isRequired,
    weldInspCat: PropTypes.object.isRequired,
    inspCatTypesDict: PropTypes.array.isRequired,
    LogModalWeldInspId: PropTypes.number
  }

  componentDidMount() {
    // withGaTracker(window.location.pathname + '/inspection_log_form') // GA TRACKER
  }

  componentWillMount() {
    this.fillFormLogDataFromProps(this.props)
    const inspection = this.props.weldInspCat && _.find(this.props.weldInspCat.inspections, (o) => o.type_id === Number(this.props.LogModalWeldInspId))
    const groupData = this.props.groupInspectionData
    const inspectionPercentage = (!this.props.editData && groupData)
      ? 100
      : (!this.props.editData && inspection) ? (this.props.weldsData[0].has_dimensional_control && !this.state.is_ri_type ? Math.min(Math.round(this.props.weldsData[0].dc_weld_failed / this.props.weldsData[0].length * 100), 100) : Number(inspection.range)) : ''
    const completeMm = (!this.props.editData && groupData)
      ? Number(this.props.weldsData[0].length)
      : inspectionPercentage ? Math.round(Number(this.props.weldsData[0].length) * (inspectionPercentage / 100)) : null
    this.setState({
      is_ri_type: this.state.ri_type_id === Number(this.props.LogModalWeldInspId),
      inspection_percentage: inspectionPercentage,
      double_length: inspection ? inspection.double_length || false : false,
      inspection: inspection || {},
      complete_mm: completeMm
    })
  }

  componentWillReceiveProps(newProps) {
    if (newProps.isOpened && !this.props.isOpened) {
      this.setState({
        nextSubmitWeldsId: null,
        submittedWeldsId: [],
        validationErrors: null,
        isSubmitting: false,
        files: [],
        filesSelectedToRemove: []
      })
    }
    this.peopleList(newProps)
    let inspection = _.find(this.props.weldInspCat.inspections, (o) => o.type_id === Number(newProps.LogModalWeldInspId))
    const groupData = newProps.groupInspectionData
    const inspectionPercentage = (!newProps.editData && groupData)
      ? 100
      : (!newProps.editData && inspection) ? (newProps.weldsData[0].has_dimensional_control && this.state.ri_type_id !== Number(newProps.LogModalWeldInspId) ? Math.min(Math.round(newProps.weldsData[0].dc_weld_failed / newProps.weldsData[0].length * 100), 100) : Number(inspection.range)) : ''
    const completeMm = (!newProps.editData && groupData)
      ? Number(newProps.weldsData[0].length)
      : inspectionPercentage ? Math.round(Number(newProps.weldsData[0].length) * (inspectionPercentage / 100)) : null
    this.setState({
      is_ri_type: this.state.ri_type_id === Number(newProps.LogModalWeldInspId),
      inspection_percentage: inspectionPercentage,
      double_length: inspection ? inspection.double_length || false : false,
      inspection: inspection || {},
      complete_mm: completeMm
    })

    this.fillFormLogDataFromProps(newProps)
  }

  fillFormLogDataFromProps(props) {
    if (props.editData) {
      let log_data = JSON.parse(props.editData.log_data) || {}
      let log_input_data = []
      for (const [k, v] of Object.entries(log_data)) {
        log_input_data.push({ additional_name: k, additional_value: v })
      }

      this.setState({
        log_data_input: log_input_data,
        person_id: props.editData.person.id,
        double_length: props.editData.double_length || false,
        gauging: props.editData.gauging || false,
        weld_failed_mm: props.editData.weld_failed != null ? Number(props.editData.weld_failed) : null
      })
    }
  }

  handleSubmit(event) {
    event.preventDefault()
    if (!this.state.person_id) {
      return this.setState({ validationErrors: [{ weld_no: this.props.weldsData[0].no, errors: ['Please select Person'] }] })
    }

    const weldFailedVal = Number(event.target.elements.weld_failed && event.target.elements.weld_failed.value) || 0
    if (!this.state.is_ri_type && this.state.complete_mm !== null && weldFailedVal > this.state.complete_mm) {
      return this.setState({ validationErrors: [{ weld_no: this.props.weldsData[0].no, errors: [`Weld failed (${weldFailedVal} mm) cannot exceed inspected length (${this.state.complete_mm} mm)`] }] })
    }

    if (this.state.isSubmitting) {
      return
    }

    this.setState({ isSubmitting: true })
    const form_elements = event.target.elements
    const dateValue = form_elements.date.value
    const formattedDate = (() => {
      const [datePart, timePart] = dateValue.split('T')
      const [year, month, day] = datePart.split('-')
      return `${day}.${month}.${year} ${timePart || '00:00'}`
    })()

    const allWeldsId = this.props.weldsData.map(weld => Number(weld.id))
    const weldsToSubmit = this.state.nextSubmitWeldsId ||
      allWeldsId.filter(id => !this.state.submittedWeldsId.includes(id))

    if (weldsToSubmit.length === 0) {
      this.setState({ isSubmitting: false })
      return
    }

    this.props.createOrUpdateLogMutation({
      variables: {
        date: formattedDate,
        note: form_elements.note.value,
        inspection_category_type_id: form_elements.inspection_category_type_id.value,
        id: this.props.editData ? this.props.editData.id : null,
        welds_id: weldsToSubmit,
        type: this.state.type,
        log_data: this.preparedLogDataTypes(),
        weld_failed: this.state.is_ri_type ? null : (this.state.weld_failed_mm != null ? this.state.weld_failed_mm : null),
        complete_percent: this.state.is_ri_type ? '100' : (() => {
            const val = form_elements.complete_percent ? form_elements.complete_percent.value : ''
            return val !== '' ? val : null
          })(),
        complete: this.state.is_ri_type ? null : (() => {
            const val = form_elements.complete ? form_elements.complete.value : ''
            return val !== '' ? Number(val) : null
          })(),
        double_length: form_elements.double_length.checked,
        gauging: form_elements.gauging.checked,
        hold_time_bypassed: this.state.bypass_hold_time,
        person_id: this.state.person_id,
        skipped: false
      }
    }).then(({ data: { createOrUpdateLogs } }) => {
      let logsErrors = []
      let nextWeldsId = []
      createOrUpdateLogs.logs.forEach(obj => {
        if (obj.errors && obj.errors.length > 0) {
          logsErrors.push({ weld_no: obj.weld.no, errors: obj.errors })
          nextWeldsId.push(Number(obj.weld.id))
        }
      })

      // TODO: Update attachments in Apollo Store GraphQL
      if (logsErrors.length > 0) {
        // withGaEvent({category: 'InspectionLog', action: ' error save'}) // GA EVENT
        const successfulLogs = createOrUpdateLogs.logs.filter(o => o.id && (!o.errors || o.errors.length === 0))
        const successfulWeldIds = successfulLogs.map(o => Number(o.weld.id))
        this.setState({
          validationErrors: logsErrors,
          nextSubmitWeldsId: nextWeldsId,
          submittedWeldsId: [...this.state.submittedWeldsId, ...successfulWeldIds],
          isSubmitting: false
        })

        let logs = createOrUpdateLogs.logs.filter(o => o.id)
        // ADD FILE
        if (logs.length > 0 && this.state.files.length > 0) {
          UploadFiles(logs.map(o => o.id), 'WlWelds::Log', this.state.files).then(() => { })
        }

      } else {
        // withGaEvent({category: 'InspectionLog', action: 'save'}) // GA EVENT
        let logs = createOrUpdateLogs.logs
        // ADD FILE
        const finish = (attachmentUrl) => {
          this.setState({ isSubmitting: false })
          this.props.afterSubmit(logs, attachmentUrl)
          this.props.onCancel()
        }

        const uploadAndFinish = () => {
          if (this.state.files.length > 0) {
            UploadFiles(logs.map(o => o.id), 'WlWelds::Log', this.state.files).then((attachments) => {
              finish(attachments[attachments.length - 1].url)
            })
          } else {
            finish()
          }
        }

        if (this.state.filesSelectedToRemove.length > 0) {
          this.props.destroyAttachmentsMutation({
            variables: {
              attachment_id: this.state.filesSelectedToRemove,
              attachable_id: Number(logs[0].id),
              attachable_type: 'WlWelds::Log'
            }
          }).then(uploadAndFinish)
        } else {
          uploadAndFinish()
        }
      }
    }).catch((error) => {
      console.error('GraphQL mutation error:', error)
      this.setState({
        isSubmitting: false,
        validationErrors: [{ weld_no: this.props.weldsData[0].no, errors: [error.message || 'An unexpected error occurred'] }]
      })
    })
  }

  handleFileAdded(file) {
    this.setState({ files: [...this.state.files, file] })
  }

  handleFileRemoved(file) {
    let newFilesList = this.state.files.filter(function (item) {
      return (item !== file)
    })

    this.setState({ files: newFilesList })
  }

  preparedLogDataTypes() {
    let zm = {}
    this.state.log_data_input.forEach(ar => {
      if (ar.additional_name !== '') {
        zm[ar.additional_name] = ar.additional_value
      }
    })
    return JSON.stringify(zm)
  }

  setSelectInspectionLogOptions() {
    if (this.props.data.inspection_log_data_types) {
      return this.props.data.inspection_log_data_types.map((insp_log, idx) => {
        return (<option key={idx} value={insp_log.id}>{insp_log.name}</option>)
      })
    }
  }

  setInspectionTypeSelectOptions() {
    if (this.props.weldInspCat) {
      return this.props.weldInspCat.inspections.map((insp, idx) => {
        return (<option key={idx} value={insp.type_id}>{
          this.props.inspCatTypesDict.find(inspCat => Number(inspCat.id) === insp.type_id).name
        }</option>)
      })
    }
  }

  handleOnSelectInspectionLogChange(event, idx) {
    let newValue = this.state.log_data_input
    newValue[idx][event.target.name] = event.target.value
    this.setState({ log_data_input: newValue })
  }

  handleDeleteInput(idx) {
    let newValue = this.state.log_data_input
    this.setState({ log_data_input: newValue.filter((s, sidx) => idx !== sidx) })
  }

  handleAddDynamicInput() {
    let newValue = this.state.log_data_input
    newValue.push({ additional_name: '', additional_value: '' })
    this.setState({ log_data_input: newValue })
  }

  handleSelectValueChange(person) {
    this.setState({ person_id: person && person.id })
  }

  getFirstWeldingDate(weld) {
    const logs = weld.logs || []
    const weldingDates = logs
      .filter(l => (l.type === 'WlWelds::Logs::Welding' || l.type === 'WlWelds::Logs::Grinding') && l.date)
      .map(l => {
        if (l.date.includes('.')) {
          const [datePart, timePart] = l.date.split(' ')
          const [day, month, year] = datePart.split('.')
          return new Date(`${year}-${month}-${day}T${timePart || '00:00'}`)
        }
        return new Date(l.date)
      })
      .filter(d => !isNaN(d))
    if (weldingDates.length > 0) return new Date(Math.min(...weldingDates))

    // fallback dla masowego logowania
    const welderRaw = weld.welder
    const welder = typeof welderRaw === 'string' ? JSON.parse(welderRaw) : welderRaw
    const welderDate = welder && welder.date
    if (!welderDate) return null
    const [datePart, timePart] = welderDate.split(' ')
    const [day, month, year] = datePart.split('.')
    return new Date(`${year}-${month}-${day}T${timePart || '00:00'}`)
  }

  getLastWeldingDate(weld) {
    const logs = weld.logs || []
    const weldingDates = logs
      .filter(l => (l.type === 'WlWelds::Logs::Welding' || l.type === 'WlWelds::Logs::Grinding') && l.date)
      .map(l => {
        if (l.date.includes('.')) {
          const [datePart, timePart] = l.date.split(' ')
          const [day, month, year] = datePart.split('.')
          return new Date(`${year}-${month}-${day}T${timePart || '00:00'}`)
        }
        return new Date(l.date)
      })
      .filter(d => !isNaN(d))
    if (weldingDates.length > 0) return new Date(Math.max(...weldingDates))

    // fallback dla masowego logowania — weld nie ma logs, ale ma welder.date
    const welderRaw = weld.welder
    const welder = typeof welderRaw === 'string' ? JSON.parse(welderRaw) : welderRaw
    const welderDate = welder && welder.date
    if (!welderDate) return null
    const [datePart, timePart] = welderDate.split(' ')
    const [day, month, year] = datePart.split('.')
    return new Date(`${year}-${month}-${day}T${timePart || '00:00'}`)
  }

  getBlockReason() {
    if (this.props.editData) return null
    const holdTime = this.props.weldInspCat && this.props.weldInspCat.hold_time

    for (const weld of this.props.weldsData) {
      // Reguła 1 & 2: brak jakiegokolwiek spawania/szlifowania blokuje wszystkie badania poza gauging,
      // lub data badania jest wcześniejsza niż data pierwszego spawania
      if (!this.state.gauging) {
        const firstWeldingDate = this.getFirstWeldingDate(weld)
        if (!firstWeldingDate) {
          return { type: 'no_welding', message: `Weld ${weld.no}: only gauging inspections are allowed before the first welding or grinding.` }
        }
        const form = document.getElementById('insp-log-form')
        const dateValue = form && form.elements.date && form.elements.date.value
        if (dateValue) {
          const inspDate = new Date(dateValue)
          const firstDate = new Date(firstWeldingDate.getFullYear(), firstWeldingDate.getMonth(), firstWeldingDate.getDate())
          const inspDateOnly = new Date(inspDate.getFullYear(), inspDate.getMonth(), inspDate.getDate())
          if (inspDateOnly < firstDate) {
            return { type: 'no_welding', message: `Weld ${weld.no}: only gauging inspections are allowed before the first welding or grinding.` }
          }
        }
      }

      // Reguła 3: hold time — tylko jeśli nie jest RI i nie zaznaczono bypass
      if (!this.state.gauging && !this.state.is_ri_type && !this.state.bypass_hold_time && holdTime) {
        const lastWeldingDate = this.getLastWeldingDate(weld)
        if (lastWeldingDate) {
          const holdUntil = new Date(lastWeldingDate.getTime() + holdTime * 60 * 60 * 1000)
          if (holdUntil > new Date()) {
            const pad = n => String(n).padStart(2, '0')
            const holdUntilStr = `${pad(holdUntil.getDate())}.${pad(holdUntil.getMonth()+1)}.${holdUntil.getFullYear()} ${pad(holdUntil.getHours())}:${pad(holdUntil.getMinutes())}`
            return { type: 'hold_time', message: `Weld ${weld.no}: hold time not met — inspection not allowed until ${holdTime}h after welding. Earliest: ${holdUntilStr}` }
          }
        }
      }
    }

    return null
  }

  handleSkipInspection() {
    if (window.confirm('Are you sure?')) {
      if (this.state.isSubmitting) {
        return
      }

      this.setState({ isSubmitting: true })
      const form = document.getElementById('insp-log-form')
      const form_elements = form.elements

      this.props.createOrUpdateLogMutation({
        variables: {
          date: form_elements.date.value,
          note: form_elements.note.value,
          inspection_category_type_id: form_elements.inspection_category_type_id.value,
          welds_id: this.state.nextSubmitWeldsId || this.props.weldsData.map(weld => Number(weld.id)),
          type: this.state.type,
          double_length: false,
          log_data: this.preparedLogDataTypes(),
          complete_percent: '0',
          complete: 0,
          weld_failed: null,
          skipped: true,
          person_id: null
        }
      }).then(({ data: { createOrUpdateLogs } }) => {
        let logsErrors = []
        let nextWeldsId = []
        createOrUpdateLogs.logs.forEach(obj => {
          if (obj.errors && obj.errors.length > 0) {
            logsErrors.push({ weld_no: obj.weld.no, errors: obj.errors })
            nextWeldsId.push(Number(obj.weld.id))
          }
        })

        if (logsErrors.length > 0) {
          this.setState({ validationErrors: logsErrors, nextSubmitWeldsId: nextWeldsId, isSubmitting: false })
          let logs = createOrUpdateLogs.logs.filter(o => o.id)
          this.props.afterSubmit(logs)
        } else {
          let logs = createOrUpdateLogs.logs
          this.setState({ isSubmitting: false })
          this.props.afterSubmit(logs)
          this.props.onCancel()
        }
      }).catch((error) => {
        console.error('GraphQL mutation error:', error)
        this.setState({ isSubmitting: false })
      })
    }
  }

  toggleRemoveAttachment(id) {
    const current = this.state.filesSelectedToRemove
    const numId = Number(id)
    this.setState({
      filesSelectedToRemove: current.includes(numId) ? current.filter(i => i !== numId) : [...current, numId]
    })
  }

  renderAdditionalFormFields() {
    return (
      <div>
        <br />
        <FormGroup>
          {this.props.weldsData.length === 1 && <Label>
            Length (according to the category, the inspection should be performed at {this.state.inspection_percentage}%,
            which is {Math.round(Number(this.props.weldsData[0].length) * (this.state.inspection_percentage / 100))} mm)
          </Label>}
          <ConvertInput
            my_value={Number(this.props.weldsData[0].length)}
            existingValue={this.props.editData ? this.props.editData.complete : null}
            defaultValue={this.state.inspection_percentage || (this.props.editData && this.props.editData.complete_percent)}
            onMillimetersChange={(mm) => this.setState({ complete_mm: mm })}
            multipleWelds={this.props.weldsData.length > 1}
          />
        </FormGroup>

        <FormGroup>
          <Label>Weld failed</Label>
          <Input
            id="weld-failed-insp-log-form"
            name="weld_failed"
            type="number"
            value={this.state.weld_failed_mm === null ? '' : this.state.weld_failed_mm}
            onChange={(e) => this.setState({ weld_failed_mm: e.target.value === '' ? null : Number(e.target.value) })}
            disabled={this.props.weldsData.length > 1}
            invalid={this.state.complete_mm !== null && this.state.weld_failed_mm > this.state.complete_mm}
          />
          {this.state.complete_mm !== null && this.state.weld_failed_mm > this.state.complete_mm &&
            <FormFeedback>Weld failed cannot exceed inspected length ({this.state.complete_mm} mm)</FormFeedback>
          }
        </FormGroup>

        <Label>Additional parameters</Label>
        {this.state.log_data_input.map((inputRecordData, idx) => {
          return (
            <div key={idx}>
              <Row>
                <Col xs="12" sm="5">
                  <Input
                    value={inputRecordData.additional_name || ''}
                    type="select"
                    name="additional_name"
                    onChange={(event) => {
                      this.handleOnSelectInspectionLogChange(event, idx)
                    }}
                  >
                    <option></option>
                    {this.setSelectInspectionLogOptions()}
                  </Input>
                </Col>
                <Col xs="12" sm="5">
                  <Input
                    name="additional_value"
                    value={inputRecordData.additional_value || ''}
                    type="text"
                    onChange={(event) => {
                      this.handleOnSelectInspectionLogChange(event, idx)
                    }}
                  />
                </Col>
                <Col sm="1">
                  <Button
                    color="danger"
                    onClick={() => {
                      this.handleDeleteInput(idx)
                    }}
                  >
                    <i className="fa fa-minus" />
                  </Button>
                </Col>
              </Row>
            </div>
          )
        })}
        <Row>
          <Col sm="1">
            <Button
              color="primary"
              style={{ marginTop: '10px' }}
              onClick={this.handleAddDynamicInput}
            >
              <i className="fa fa-plus" />
            </Button>
          </Col>
        </Row>
        <br />
      </div>
    )
  }

  render() {
    const config = this.componentConfig
    const djsConfig = this.djsConfig
    const eventHandlers = {
      init: dz => this.dropzone = dz,
      addedfile: this.handleFileAdded.bind(this),
      removedfile: this.handleFileRemoved.bind(this)
    }

    if (this.props.data.error) {
      return (<div>An unexpected error occurred</div>)
    }

    return (
      < BlockWithLoader loading={this.props.data.loading} >
        <Modal isOpen={this.props.isOpened} backdrop={this.state.isSubmitting ? "static" : true} keyboard={!this.state.isSubmitting}>
          <ModalHeader>Inspection Modal</ModalHeader>
          <ModalBody>
            <Form id="insp-log-form" className="FormClassLabel" onSubmit={this.handleSubmit}>
              <CreatableSelect label="Person" id="select-person-insp-log-form"
                options={this.state.people_list}
                valueKey="id"
                value={this.state.person_id}
                multi={false}
                creatable={false}
                valueChangeFunction={this.handleSelectValueChange}
              />
              <FormGroup>
                <Label>Date</Label>
                <Input
                  id="date-insp-log-form"
                  name="date"
                  type="datetime-local"
                  defaultValue={(this.props.editData && this.props.editData.date && (() => {
                    const [datePart, timePart] = this.props.editData.date.split(' ')
                    const [day, month, year] = datePart.split('.')
                    return `${year}-${month}-${day}T${timePart || '00:00'}`
                  })()) || (() => {
                    const now = new Date()
                    const year = now.getFullYear()
                    const month = String(now.getMonth() + 1).padStart(2, '0')
                    const day = String(now.getDate()).padStart(2, '0')
                    return `${year}-${month}-${day}T00:00`
                  })()}
                  onChange={(e) => this.setState({ inspectionDateValue: e.target.value })}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label>Inspection type</Label>
                <Input
                  id="insp-type-insp-log-form"
                  name="inspection_category_type_id"
                  type="select"
                  required
                  defaultValue={this.props.LogModalWeldInspId}
                  onChange={(e) => {
                    let inspection = _.find(this.props.weldInspCat.inspections, (o) => o.type_id === Number(e.target.value))
                    const inspPct = (this.props.weldsData[0].has_dimensional_control && this.state.ri_type_id !== Number(e.target.value)) ? Math.min(Math.round(this.props.weldsData[0].dc_weld_failed / this.props.weldsData[0].length * 100), 100) : ((inspection && Number(inspection.range)) || 0)
                    this.setState({
                      is_ri_type: this.state.ri_type_id === Number(e.target.value),
                      inspection_percentage: inspPct,
                      inspection: inspection || {},
                      double_length: inspection ? inspection.double_length || false : false,
                      complete_mm: inspPct ? Math.round(Number(this.props.weldsData[0].length) * (inspPct / 100)) : null
                    })
                  }}>
                  <option></option>
                  {this.setInspectionTypeSelectOptions()}
                </Input>
              </FormGroup>
              <FormGroup>
                <div className="checkbox">
                  <label>
                    <input
                      type="checkbox"
                      name="double_length"
                      checked={this.state.double_length}
                      onChange={(e) => this.setState({ double_length: e.target.checked })}
                    /> Double length
                  </label>
                </div>
                <div className="checkbox">
                  <label>
                    <input
                      type="checkbox"
                      name="gauging"
                      checked={this.state.gauging}
                      onChange={(e) => this.setState({ gauging: e.target.checked })}
                    /> Gauging
                  </label>
                </div>
                {!!getUserPermissions('wl_welds.inspection_logs.bypass_hold_time') && !this.state.is_ri_type && <div className="checkbox">
                  <label>
                    <input
                      type="checkbox"
                      name="bypass_hold_time"
                      checked={this.state.bypass_hold_time}
                      onChange={(e) => this.setState({ bypass_hold_time: e.target.checked })}
                    /> Bypass hold time
                  </label>
                </div>}
              </FormGroup>

              {!this.state.is_ri_type && this.renderAdditionalFormFields()}

              <Label>Note</Label>
              <Input
                type="textarea"
                name="note"
                defaultValue={(this.props.editData && this.props.editData.note) || ''}
              />
              <br />
              <DropzoneComponent config={config} eventHandlers={eventHandlers} djsConfig={djsConfig} />
              {this.props.editData && this.props.editData.attachments && this.props.editData.attachments.length > 0 &&
                <aside>
                  <br />
                  <h6>Attached files:</h6>
                  <ol className="attachment-list" style={{ listStyle: 'none', paddingLeft: 0 }}>
                    {this.props.editData.attachments.map(f => {
                      const markedForRemoval = this.state.filesSelectedToRemove.includes(Number(f.id))
                      return (
                        <li key={f.id} style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                          <a
                            href={API_BASE_URL + f.url}
                            target='blank'
                            style={markedForRemoval ? { textDecoration: 'line-through', color: '#999', flex: 1 } : { flex: 1 }}
                          >
                            {f.data_file_name}
                          </a>
                          <i
                            className="fa fa-times"
                            style={{ color: markedForRemoval ? '#999' : 'red', cursor: 'pointer', marginLeft: '8px' }}
                            title={markedForRemoval ? 'Undo remove' : 'Remove attachment'}
                            onClick={() => this.toggleRemoveAttachment(f.id)}
                          />
                        </li>
                      )
                    })}
                  </ol>
                </aside>
              }
              <br />
              {this.state.validationErrors &&
                this.state.validationErrors.map((obj, i) => <h4 key={i} className="errors-heading ">
                  {`Weld No: ${obj.weld_no} -> ${obj.errors.join(', ')}`}
                </h4>)
              }
              {(() => {
                const reason = this.getBlockReason()
                if (!reason) return null
                return <p style={{ color: 'red', fontWeight: 'bold' }}>{reason.message}</p>
              })()}
              <FormGroup>
                <Button id="cancel-insp-log-form-btn" className="float-right" color="danger"
                  onClick={this.props.onCancel} disabled={this.state.isSubmitting}>Cancel</Button>
                <Button id="save-insp-log-form-btn" className="float-right" color="primary" type="submit"
                  disabled={this.state.isSubmitting || !!this.getBlockReason()}>
                  {this.state.isSubmitting ? 'Saving...' : 'Save'}
                </Button>
                <Button id="skip-insp-log-form-btn" className="float-left" color="warning"
                  onClick={this.handleSkipInspection} disabled={this.state.isSubmitting}>Skip Inspection</Button>
              </FormGroup>
            </Form>
          </ModalBody>
        </Modal>
      </BlockWithLoader >
    )
  }
}

const LogsModalWithMutations = compose(
  graphql(InspectionLogDataFetchQuery, {
    options: {
      fetchPolicy: 'network-only',
      variables: { filters: { permission_key: 'core.people.inspector', active: 'true' } }
    }
  }),
  graphql(createOrUpdateLogMutation, { name: 'createOrUpdateLogMutation' }),
  graphql(destroyAttachmentsMutation, { name: 'destroyAttachmentsMutation' })
)(InspectionLogModal)

export default LogsModalWithMutations



// WEBPACK FOOTER //
// ./src/components/EventLog/InspectionLogModal.js